export const patientAdvices = [
  {
    value: "Drink plenty of water and stay hydrated.",
    label: "Drink plenty of water and stay hydrated.",
    translations: {
      hi: "पर्याप्त पानी पिएं और हाइड्रेटेड रहें।",
      bn: "প্রচুর পানি পান করুন এবং হাইড্রেটেড থাকুন।",
      mr: "पुरे पाणी प्या आणि हायड्रेटेड रहा.",
      te: "చాలా నీరు త్రాగండి మరియు హైడ్రేటెడ్‌గా ఉండండి.",
      ta: "நிறைய தண்ணீர் குடிக்கவும் மற்றும் ஈரப்பதமாக இருங்கள்.",
      gu: "ઘણું પાણી પીવો અને હાઇડ્રેટેડ રહો.",
      as: "বহুত পানী খাব আৰু হাইড্ৰেটেড থাকিব।",
      kn: "ಹೆಚ್ಚು ನೀರು ಕುಡಿಯಿರಿ ಮತ್ತು ಹೈಡ್ರೇಟೆಡ್ ಆಗಿರಿ.",
      ml: "കൂടുതൽ വെള്ളം കുടിക്കുക, ഹൈഡ്രേറ്റഡ് ആയിരിക്കുക.",
      pa: "ਵਧੇਰੇ ਪਾਣੀ ਪੀਓ ਅਤੇ ਹਾਈਡ੍ਰੇਟ ਰਹੋ।"
    }
  },
  {
    value: "Take your medications exactly as prescribed.",
    label: "Take your medications exactly as prescribed.",
    translations: {
      hi: "दवाइयाँ डॉक्टर के निर्देशानुसार ही लें।",
      bn: "ডাক্তারের পরামর্শ অনুযায়ী ওষুধ খান।",
      mr: "औषधे डॉक्टरांच्या सूचनेनुसार घ्या.",
      te: "డాక్టర్ సూచించిన విధంగా మందులు తీసుకోండి.",
      ta: "மருத்துவர் பரிந்துரைத்தபடி மருந்துகளை எடுத்துக்கொள்ளவும்.",
      gu: "ડૉક્ટર જણાવ્યા મુજબ દવાઓ લો.",
      as: "ডাক্তৰৰ পৰামৰ্শ অনুসৰি ঔষধ খাব।",
      kn: "ವೈದ್ಯರ ಸೂಚನೆಯಂತೆ ಔಷಧಿಗಳನ್ನು ತೆಗೆದುಕೊಳ್ಳಿ.",
      ml: "ഡോക്ടർ നിർദേശിച്ചതുപോലെ മരുന്നുകൾ കഴിക്കുക.",
      pa: "ਡਾਕਟਰ ਦੀ ਹਦਾਇਤ ਅਨੁਸਾਰ ਦਵਾਈਆਂ ਲਵੋ।"
    }
  },
  {
    value: "Get at least 7-8 hours of sleep every night.",
    label: "Get at least 7-8 hours of sleep every night.",
    translations: {
      hi: "हर रात कम से कम 7-8 घंटे की नींद लें।",
      bn: "প্রতিদিন রাতে অন্তত ৭-৮ ঘণ্টা ঘুমান।",
      mr: "दररोज किमान ७-८ तास झोप घ्या.",
      te: "ప్రతి రాత్రి కనీసం 7-8 గంటలు నిద్రపోండి.",
      ta: "ஒவ்வொரு இரவும் குறைந்தது 7-8 மணி நேரம் தூங்குங்கள்.",
      gu: "દરરોજ રાત્રે ઓછામાં ઓછા 7-8 કલાક ઊંઘો.",
      as: "প্ৰতি ৰাতি কমেও ৭-৮ ঘণ্টা টোপনি লওক।",
      kn: "ಪ್ರತಿ ರಾತ್ರಿ ಕನಿಷ್ಠ 7-8 ಗಂಟೆ ನಿದ್ರೆ ಮಾಡಿ.",
      ml: "പ്രതി രാത്രി കുറഞ്ഞത് 7-8 മണിക്കൂർ ഉറങ്ങുക.",
      pa: "ਹਰ ਰਾਤ ਘੱਟੋ-ਘੱਟ 7-8 ਘੰਟੇ ਦੀ ਨੀਂਦ ਲਵੋ।"
    }
  },
  {
    value: "Eat a balanced diet rich in fruits and vegetables.",
    label: "Eat a balanced diet rich in fruits and vegetables.",
    translations: {
      hi: "फल और सब्जियों से भरपूर संतुलित आहार लें।",
      bn: "ফল এবং শাকসবজিতে সমৃদ্ধ সুষম খাদ্য খান।",
      mr: "फळे आणि भाज्यांनी समृद्ध संतुलित आहार घ्या.",
      te: "పండ్లు మరియు కూరగాయలతో సమృద్ధిగా ఉన్న సమతుల్య ఆహారం తినండి.",
      ta: "பழங்கள் மற்றும் காய்கறிகள் நிறைந்த சமநிலையான உணவு உண்ணுங்கள்.",
      gu: "ફળો અને શાકભાજીથી ભરપૂર સંતુલિત આહાર લો.",
      as: "ফল-মূল আৰু শাক-পাচলিৰে সমৃদ্ধ সুষম আহাৰ গ্ৰহণ কৰক।",
      kn: "ಹಣ್ಣುಗಳು ಮತ್ತು ತರಕಾರಿಗಳಿಂದ ಸಮೃದ್ಧವಾದ ಸಮತೋಲನ ಆಹಾರವನ್ನು ಸೇವಿಸಿ.",
      ml: "ഫലങ്ങളും പച്ചക്കറികളും അടങ്ങിയ സമതുലിതാഹാരം കഴിക്കുക.",
      pa: "ਫਲਾਂ ਅਤੇ ਸਬਜ਼ੀਆਂ ਨਾਲ ਭਰਪੂਰ ਸੰਤੁਲਿਤ ਆਹਾਰ ਲਵੋ।"
    }
  },
  {
    value: "Exercise regularly, at least 30 minutes a day.",
    label: "Exercise regularly, at least 30 minutes a day.",
    translations: {
      hi: "नियमित व्यायाम करें, रोज़ कम से कम 30 मिनट।",
      bn: "নিয়মিত ব্যায়াম করুন, প্রতিদিন অন্তত ৩০ মিনিট।",
      mr: "नियमित व्यायाम करा, दररोज किमान ३० मिनिटे.",
      te: "ప్రతి రోజు కనీసం 30 నిమిషాలు వ్యాయామం చేయండి.",
      ta: "ஒவ்வொரு நாளும் குறைந்தது 30 நிமிடம் உடற்பயிற்சி செய்யுங்கள்.",
      gu: "નિયમિત કસરત કરો, દરરોજ ઓછામાં ઓછા 30 મિનિટ.",
      as: "নিয়মিত ব্যায়াম কৰক, প্ৰতিদিন কমেও ৩০ মিনিট।",
      kn: "ನಿಯಮಿತವಾಗಿ ವ್ಯಾಯಾಮ ಮಾಡಿ, ದಿನಕ್ಕೆ ಕನಿಷ್ಠ 30 ನಿಮಿಷಗಳು.",
      ml: "പ്രതിദിനം കുറഞ്ഞത് 30 മിനിറ്റ് വ്യായാമം ചെയ്യുക.",
      pa: "ਨਿਯਮਤ ਵਰਜ਼ਿਸ਼ ਕਰੋ, ਹਰ ਰੋਜ਼ ਘੱਟੋ-ਘੱਟ 30 ਮਿੰਟ।"
    }
  },
  {
    value: "Avoid smoking and limit alcohol consumption.",
    label: "Avoid smoking and limit alcohol consumption.",
    translations: {
      hi: "धूम्रपान से बचें और शराब का सेवन सीमित करें।",
      bn: "ধূমপান এড়িয়ে চলুন এবং মদ্যপান সীমিত করুন।",
      mr: "धूम्रपान टाळा आणि मद्यपान मर्यादित ठेवा.",
      te: "పొగ త్రాగడం నివారించండి మరియు మద్యం సేవనాన్ని పరిమితం చేయండి.",
      ta: "புகைபிடிப்பதை தவிர்க்கவும் மற்றும் மதுபானம் குடிப்பதை கட்டுப்படுத்தவும்.",
      gu: "ધૂમ્રપાન ટાળો અને દારૂનું સેવન મર્યાદિત કરો.",
      as: "ধূমপান এৰাই চলক আৰু মদ্যপান সীমিত কৰক।",
      kn: "ಧೂಮಪಾನವನ್ನು ತಪ್ಪಿಸಿ ಮತ್ತು ಮದ್ಯಪಾನವನ್ನು ನಿಯಂತ್ರಿಸಿ.",
      ml: "പുകവലി ഒഴിവാക്കുക, മദ്യപാനം നിയന്ത്രിക്കുക.",
      pa: "ਧੂਮਰਪਾਨ ਤੋਂ ਬਚੋ ਅਤੇ ਸ਼ਰਾਬ ਦੀ ਖਪਤ ਘੱਟ ਕਰੋ।"
    }
  },
  {
    value: "Schedule regular health check-ups.",
    label: "Schedule regular health check-ups.",
    translations: {
      hi: "नियमित स्वास्थ्य जांच कराएं।",
      bn: "নিয়মিত স্বাস্থ্য পরীক্ষা করান।",
      mr: "नियमित आरोग्य तपासणी करा.",
      te: "నియమిత ఆరోగ్య పరీక్షలు చేయించుకోండి.",
      ta: "நியமித உடல் பரிசோதனைகளை மேற்கொள்ளுங்கள்.",
      gu: "નિયમિત આરોગ્ય ચકાસણીઓ કરો.",
      as: "নিয়মিত স্বাস্থ্য পৰীক্ষা কৰক।",
      kn: "ನಿಯಮಿತ ಆರೋಗ್ಯ ತಪಾಸಣೆಗಳನ್ನು ಮಾಡಿಸಿ.",
      ml: "നിയമിത ആരോഗ്യ പരിശോധനകൾ നടത്തുക.",
      pa: "ਨਿਯਮਤ ਸਿਹਤ ਜਾਂਚ ਕਰਵਾਓ।"
    }
  },
  {
    value: "Wash your hands frequently to prevent infections.",
    label: "Wash your hands frequently to prevent infections.",
    translations: {
      hi: "संक्रमण से बचने के लिए बार-बार हाथ धोएं।",
      bn: "সংক্রমণ এড়াতে বারবার হাত ধুয়ে নিন।",
      mr: "संसर्ग टाळण्यासाठी वारंवार हात धुवा.",
      te: "సంక్రమణ నివారించడానికి తరచుగా చేతులు కడగండి.",
      ta: "பாதிப்புகளைத் தவிர்க்க அடிக்கடி கைகளை கழுவுங்கள்.",
      gu: "સંક્રમણથી બચવા વારંવાર હાથ ધોવો.",
      as: "সংক্রমণ এৰাই চলক, বারম্বাৰ হাত ধুব।",
      kn: "ಸಂಕ್ರಮಣವನ್ನು ತಪ್ಪಿಸಲು ನಿಯಮಿತವಾಗಿ ಕೈಗಳನ್ನು ತೊಳೆಯಿರಿ.",
      ml: "സംക്രമണം ഒഴിവാക്കാൻ ഇടയ്ക്കിടെ കൈ കഴുകുക.",
      pa: "ਇੰਫੈਕਸ਼ਨ ਤੋਂ ਬਚਣ ਲਈ ਵਾਰ-ਵਾਰ ਹੱਥ ਧੋਵੋ।"
    }
  },
  {
    value: "Manage stress through relaxation techniques.",
    label: "Manage stress through relaxation techniques.",
    translations: {
      hi: "तनाव को कम करने के लिए विश्राम तकनीकों का उपयोग करें।",
      bn: "চাপ কমাতে বিশ্রামের কৌশল ব্যবহার করুন।",
      mr: "तणाव कमी करण्यासाठी विश्रांती तंत्रांचा वापर करा.",
      te: "ఆరోగ్యకరమైన విశ్రాంతి పద్ధతులతో ఒత్తిడిని తగ్గించండి.",
      ta: "மன அழுத்தத்தை குறைக்க தளர்வு நுட்பங்களை பயன்படுத்துங்கள்.",
      gu: "તણાવ ઘટાડવા આરામની ટેકનિકનો ઉપયોગ કરો.",
      as: "উত্কণ্ঠা কমাবলৈ বিশ্রাম কৌশল ব্যৱহাৰ কৰক।",
      kn: "ಒತ್ತಡವನ್ನು ಕಡಿಮೆ ಮಾಡಲು ವಿಶ್ರಾಂತಿ ತಂತ್ರಗಳನ್ನು ಬಳಸಿ.",
      ml: "മനസ്സ് ശമിപ്പാൻ വിശ്രമ സാങ്കേതിക വിദ്യകൾ ഉപയോഗിക്കുക.",
      pa: "ਤਣਾਅ ਘਟਾਉਣ ਲਈ ਆਰਾਮ ਤਕਨੀਕਾਂ ਵਰਤੋ।"
    }
  },
  {
    value: "Contact the clinic if symptoms worsen or new symptoms appear.",
    label: "Contact the clinic if symptoms worsen or new symptoms appear.",
    translations: {
      hi: "लक्षण बढ़ने या नए लक्षण दिखने पर क्लिनिक से संपर्क करें।",
      bn: "লক্ষণগুলি বাড়লে বা নতুন লক্ষণ দেখা দিলে ক্লিনিকের সাথে যোগাযোগ করুন।",
      mr: "लक्षणे वाढल्यास किंवा नवीन लक्षणे दिसल्यास क्लिनिकशी संपर्क साधा.",
      te: "లక్షణాలు పెరిగితే లేదా కొత్త లక్షణాలు కనిపిస్తే క్లినిక్‌ను సంప్రదించండి.",
      ta: "அறிகுறிகள் அதிகரித்தால் அல்லது புதிய அறிகுறிகள் தோன்றினால் கிளினிக்கை தொடர்பு கொள்ளவும்.",
      gu: "લક્ષણો વધે અથવા નવા લક્ષણો દેખાય તો ક્લિનિકનો સંપર્ક કરો.",
      as: "লক্ষণ বৃদ্ধি পালে বা নতুন লক্ষণ দেখা দিলে ক্লিনিকৰ সৈতে যোগাযোগ কৰক।",
      kn: "ಲಕ್ಷಣಗಳು ಹೆಚ್ಚಾದರೆ ಅಥವಾ ಹೊಸ ಲಕ್ಷಣಗಳು ಕಾಣಿಸಿಕೊಂಡರೆ ಕ್ಲಿನಿಕ್ ಅನ್ನು ಸಂಪರ್ಕಿಸಿ.",
      ml: "ലക്ഷണങ്ങൾ കൂടുകയോ പുതിയ ലക്ഷണങ്ങൾ കാണപ്പെടുകയോ ചെയ്താൽ ക്ലിനിക്കുമായി ബന്ധപ്പെടുക.",
      pa: "ਲੱਛਣ ਵਧ ਜਾਣ ਜਾਂ ਨਵੇਂ ਲੱਛਣ ਆ ਜਾਣ ਤਾਂ ਕਲੀਨਿക ਨਾਲ ਸੰਪਰਕ ਕਰੋ।"
    }
  }
]; 